import { UserDevicesService } from './user-devices.service';

export default angular
  .module('sfMobile.services.user-devices', [
    'sfMobile.services.profile',
    'sfMobile.services.users',
    'sfMobile.services.objectId',
  ])
  .service('userDevicesService', UserDevicesService).name;
